import { getAllowedOrderTicketCountForShowtime } from './get-allowed-order-ticket-count-for-showtime';
import { getOrderTicketCountForShowtime } from './get-order-ticket-count-for-showtime';
export const getRemainingOrderTicketCountForShowtime = (showtimeId) => {
    const maximumCount = getAllowedOrderTicketCountForShowtime(showtimeId);
    const currentCount = getOrderTicketCountForShowtime(showtimeId);
    return maximumCount - currentCount;
};
